import { createSlice } from '@reduxjs/toolkit';
import { SLICE } from 'modules/dashboard/constants';

export const initialState = {
  loading: false,
  response: null,
  error: null,
  history: [],
  nextCursor: null,
  historyLoading: false,
  historyLoaded: false,
  historyError: null,
  clearingHistory: false,
};

export const customChatSlice = createSlice({
  name: SLICE.CUSTOM_CHAT,
  initialState,
  reducers: {
    sendMessage(state) {
      state.loading = true;
      state.response = null;
      state.error = null;
    },
    sendMessageSucceeded(state, action) {
      state.loading = false;
      state.response = action.payload;
    },
    sendMessageFailed(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetChat(state) {
      state.loading = false;
      state.response = null;
      state.error = null;
    },
    fetchChatHistory(state) {
      state.historyLoading = true;
      state.historyError = null;
    },
    fetchChatHistorySucceeded(state, action) {
      const { results, nextCursor, before } = action.payload;
      state.historyLoading = false;
      state.historyLoaded = true;
      state.history = before ? [...results, ...state.history] : results;
      state.nextCursor = nextCursor ?? null;
    },
    fetchChatHistoryFailed(state, action) {
      state.historyLoading = false;
      state.historyError = action.payload;
    },
    clearChatHistory(state) {
      state.clearingHistory = true;
      state.historyLoading = false;
    },
    clearChatHistorySucceeded(state) {
      state.clearingHistory = false;
      state.historyLoaded = true;
      state.history = [];
      state.nextCursor = null;
    },
    clearChatHistoryFailed(state, action) {
      state.clearingHistory = false;
      state.historyError = action.payload;
    },
    resetChatHistory(state) {
      state.history = [];
      state.nextCursor = null;
      state.historyLoading = false;
      state.historyLoaded = false;
      state.historyError = null;
      state.clearingHistory = false;
    },
  },
});

export const { actions: customChatActions } = customChatSlice;
